// src/hooks/useNotifications.js — iOS SAFE VERSION
import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'

function safeGetPermission() {
  try { return (typeof Notification !== 'undefined') ? Notification.permission : 'unsupported' }
  catch { return 'unsupported' }
}

function notifSupported() {
  try { return typeof Notification !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window }
  catch { return false }
}

async function saveSubscription(userId, sub) {
  try {
    const s = sub.toJSON()
    await supabase.from('push_subscriptions').upsert({ user_id:userId, endpoint:s.endpoint, p256dh:s.keys?.p256dh, auth:s.keys?.auth, updated_at:new Date().toISOString() }, { onConflict:'user_id' })
  } catch {}
}

export function usePushNotifications(userId) {
  const [permission, setPermission] = useState(() => safeGetPermission())
  const [subscribed, setSubscribed] = useState(false)
  const [loading, setLoading]       = useState(false)

  useEffect(() => {
    if (!notifSupported()) return
    try { navigator.serviceWorker.register('/sw.js').catch(()=>{}) } catch {}
  }, [])

  useEffect(() => {
    if (!userId || !notifSupported()) return
    try { navigator.serviceWorker.ready.then(r=>r.pushManager.getSubscription()).then(s=>{ if(s) setSubscribed(true) }).catch(()=>{}) } catch {}
  }, [userId])

  const requestPermission = useCallback(async () => {
    if (!userId || !notifSupported()) return
    setLoading(true)
    try {
      const perm = await Notification.requestPermission()
      setPermission(perm)
      if (perm === 'granted') {
        const reg = await navigator.serviceWorker.ready
        const sub = await reg.pushManager.subscribe({ userVisibleOnly:true }).catch(()=>null)
        if (sub) { await saveSubscription(userId, sub); setSubscribed(true) }
      }
    } catch {}
    setLoading(false)
  }, [userId])

  const unsubscribe = useCallback(async () => {
    try {
      const reg = await navigator.serviceWorker.ready
      const sub = await reg.pushManager.getSubscription()
      if (sub) { await sub.unsubscribe(); await supabase.from('push_subscriptions').delete().eq('user_id',userId); setSubscribed(false) }
    } catch {}
  }, [userId])

  return { permission, subscribed, loading, requestPermission, unsubscribe }
}

export function showLocalNotification(title, body, url='/dashboard') {
  try {
    if (!notifSupported() || Notification.permission !== 'granted') return
    navigator.serviceWorker.ready.then(r=>r.showNotification(title,{body,icon:'/favicon.ico',data:{url}})).catch(()=>{})
  } catch {}
}
